(function () {
  'use strict';

  var COLLAPSE_LIMIT = 2;
  var ROOT_SELECTOR = '#shopify-section-template--1782375626c7c1f805__1782375626c7c1f805, [id*="1782375626c7c1f805"], [class*="lai"][class*="review"], [id*="lai"][id*="review"]';
  var ITEM_SELECTORS = [
    '[class*="review-card"]',
    '[class*="review_item"]',
    '[class*="review-item"]',
    '[class*="ReviewItem"]',
    '[class*="review-list"] > *',
    '[class*="reviews-list"] > *',
    '[data-review-id]',
    '[data-id][class*="review"]'
  ];
  var CONTROL_WORDS = [
    'レビューを書く',
    'すべてのレビュー',
    'レビューを並べ替える',
    'レビューをもっと見る',
    'レビューを閉じる'
  ];

  function hasText(element, text) {
    return (element.textContent || '').indexOf(text) !== -1;
  }

  function isLikelyControl(element) {
    var text = (element.textContent || '').trim();

    if (!text) {
      return true;
    }

    if (element.matches('button, select, option, input, form, summary')) {
      return true;
    }

    return CONTROL_WORDS.some(function (word) {
      return text.indexOf(word) !== -1;
    });
  }

  function isReviewItem(element, root) {
    if (!element || element === root || element.classList.contains('lai-review-collapse__toggle-wrap')) {
      return false;
    }

    if (isLikelyControl(element)) {
      return false;
    }

    var text = (element.textContent || '').trim();
    if (text.length < 12) {
      return false;
    }

    var hasDate = /\d{4}[\/.-]\d{1,2}[\/.-]\d{1,2}/.test(text);
    var hasStar = /★|☆|スター|星/.test(text);
    var hasParagraph = element.querySelector('p, [class*="content"], [class*="body"], [class*="comment"], [class*="text"]');
    var hasReviewClass = /review/i.test(element.className || '');

    if (!hasDate && !hasStar && !hasReviewClass && !hasParagraph) {
      return false;
    }

    var nestedItems = element.querySelectorAll(ITEM_SELECTORS.join(','));
    if (nestedItems.length > 1) {
      return false;
    }

    return true;
  }

  function uniqueElements(elements) {
    var seen = [];
    Array.prototype.forEach.call(elements, function (element) {
      if (seen.indexOf(element) === -1) {
        seen.push(element);
      }
    });
    return seen;
  }

  function getRoots() {
    var roots = uniqueElements(document.querySelectorAll(ROOT_SELECTOR));
    return roots.filter(function (root) {
      return /レビュー|review|lai/i.test([root.id, root.className, root.textContent].join(' '));
    });
  }

  /* KGY-LAI-REVIEW-JUMP-20261014 BEGIN: resolve the async LAI review section before scrolling. */
  function getReviewJumpTarget(link) {
    var stableSection = document.querySelector(
      '[id^="shopify-section-"][id*="1782375626c7c1f805"]'
    );

    if (stableSection && !stableSection.contains(link)) {
      return stableSection;
    }

    var appTarget = document.querySelector(
      '#scm-reviews-importer, .scm-reviews-importer, .sma-load-iframe, [class*="lai-review-section"], [id*="lai-review-section"]'
    );

    if (appTarget && !appTarget.closest('.product__block--lai-star-rating')) {
      return appTarget;
    }

    return getRoots().find(function (root) {
      return !root.contains(link) && !root.closest('.product__block--lai-star-rating');
    });
  }

  function jumpToReviews(link, attempt) {
    var target = getReviewJumpTarget(link);
    if (!target) {
      if (attempt < 12) {
        window.setTimeout(function () {
          jumpToReviews(link, attempt + 1);
        }, 250);
      }
      return;
    }

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var stickyOffset = window.innerWidth < 768 ? 150 : 190;
    var top = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.kgy-lai-review-link');
    if (!link) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    jumpToReviews(link, 0);
  }, true);
  /* KGY-LAI-REVIEW-JUMP-20261014 END */

  /* KGY-LAI-MOBILE-LAYOUT-20261014 BEGIN: layout only; colors remain controlled by LAI. */
  var LAI_MOBILE_LAYOUT_STYLE_ID = 'kgy-lai-mobile-layout';
  var LAI_MOBILE_LAYOUT_CSS = `
    @media (max-width: 500px) {
      body.header-default-4.body-default-4:not(.popup-write-review) {
        padding: 0 12px 24px;
      }

      .header-default-4 .header-container {
        padding-top: 0;
      }

      .header-default-4 .left-header,
      .header-default-4 .right-header {
        flex: 0 0 100%;
        max-width: 100%;
        margin-bottom: 10px;
      }

      .header-default-4 .group-rating-avenge {
        justify-content: flex-start;
      }

      .header-default-4 .right-header {
        display: block;
      }

      .header-default-4 .write-review-button {
        display: block;
        width: 100%;
        min-height: 42px;
        margin: 0;
        box-sizing: border-box;
      }

      .header-default-4 .rating-option-group {
        display: block;
        padding-top: 10px;
      }

      .header-default-4 .rating-option-group .group-progress-bar {
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        width: 100%;
        max-width: 100%;
        padding: 0 0 4px;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        scroll-snap-type: x proximity;
      }

      .header-default-4 .rating-option-group .group-progress-bar::-webkit-scrollbar {
        display: none;
      }

      .header-default-4 .group-progress-bar .item-progress-bar {
        flex: 0 0 auto;
        margin: 0 6px 0 0;
        padding: 10px 12px 9px;
        scroll-snap-align: start;
        white-space: nowrap;
      }

      .header-default-4 .rating-option-group .container-sort {
        display: block;
        width: 100%;
        margin: 10px 0 0;
      }

      .header-default-4 .rating-option-group .scm-sort {
        float: none;
        width: 100%;
        min-width: 0;
      }

      .header-default-4 .rating-option-group .scm-sort .scm-sort-title {
        justify-content: center;
        width: 100%;
        min-height: 42px;
        box-sizing: border-box;
      }

      .header-default-4:not(.body-default-4) #reviewImporter,
      .header-default-4.body-default-4 #reviewImporter {
        margin-top: 4px;
      }

      .body-default-4 .list .item {
        padding: 18px 0 14px;
      }

      .body-default-4 .list .left-list,
      .body-default-4 .list .center-list,
      .body-default-4 .list .right-list {
        flex: 0 0 100%;
        max-width: 100%;
        margin-left: 0;
      }

      .body-default-4 .list .left-list {
        margin-bottom: 8px;
      }

      .body-default-4 .list .center-list {
        margin-bottom: 10px;
      }

      .body-default-4 .list .right-list {
        margin-bottom: 0;
      }

      .body-default-4 .list .thumb-img {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 0;
        padding: 0;
        text-align: left;
      }

      .body-default-4 .list .thumb-img .wrap-image {
        margin: 0;
      }

      .body-default-4 .list .thumb-img img,
      .body-default-4 .list .number-img {
        width: 72px;
        height: 72px;
        object-fit: cover;
      }
    }
  `;

  function installLaiMobileLayout(frame) {
    try {
      var iframeDocument = frame.contentDocument;
      if (!iframeDocument || !iframeDocument.head) {
        return false;
      }

      if (!iframeDocument.getElementById(LAI_MOBILE_LAYOUT_STYLE_ID)) {
        var style = iframeDocument.createElement('style');
        style.id = LAI_MOBILE_LAYOUT_STYLE_ID;
        style.textContent = LAI_MOBILE_LAYOUT_CSS;
        iframeDocument.head.appendChild(style);
      }

      if (frame.contentWindow) {
        frame.contentWindow.dispatchEvent(new frame.contentWindow.Event('resize'));
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  function setupLaiMobileLayouts() {
    document.querySelectorAll('iframe.scm-reviews-importer-iframe').forEach(function (frame) {
      if (frame.dataset.kgyLaiMobileLayoutReady !== 'true') {
        frame.dataset.kgyLaiMobileLayoutReady = 'true';
        frame.addEventListener('load', function () {
          window.setTimeout(function () {
            installLaiMobileLayout(frame);
          }, 0);
        });
      }
      installLaiMobileLayout(frame);
    });
  }
  /* KGY-LAI-MOBILE-LAYOUT-20261014 END */

  /* KGY-LAI-PHOTO-LAYOUT-20261014 BEGIN: compact photo header; colors remain controlled by LAI. */
  var LAI_PHOTO_LAYOUT_STYLE_ID = 'kgy-lai-photo-layout';
  var LAI_PHOTO_LAYOUT_CSS = `
    .header-default-6 .images-container-reviews {
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start;
      gap: 8px;
      max-width: none;
      max-height: none;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      scroll-snap-type: x proximity;
    }

    .header-default-6 .images-container-reviews::-webkit-scrollbar {
      display: none;
    }

    .header-default-6 .images-container-reviews .item {
      flex: 0 0 auto;
      width: auto;
      scroll-snap-align: start;
    }

    .header-default-6 .images-container-reviews .thumb-img,
    .header-default-6 .images-container-reviews .wrap-image {
      display: flex;
      margin: 0;
    }

    .header-default-6 .images-container-reviews .info-reviews {
      display: none;
    }

    @media (min-width: 769px) {
      .header-default-6 .header-container .scm-row {
        align-items: center;
      }

      .header-default-6.has-photo-header .left-header {
        flex: 1 1 auto;
        width: auto;
        max-width: calc(100% - 180px);
      }

      .header-default-6 .right-header {
        flex: 0 0 180px;
        width: 180px;
        max-width: 180px;
      }

      .header-default-6 .scm-rating {
        align-items: center;
        width: 100%;
      }

      .header-default-6 .scmRating1 {
        flex: 0 0 155px;
        width: 155px;
      }

      .header-default-6 .scmRating2 {
        flex: 0 0 260px;
        width: 260px;
        padding: 0 24px;
      }

      .header-default-6 .scmRating3 {
        flex: 1 1 auto;
        width: auto;
        min-width: 0;
        padding-left: 24px;
      }

      .header-default-6 .images-container-reviews .thumb-img img,
      .header-default-6 .images-container-reviews .number-img {
        width: 88px;
        height: 88px;
        margin: 0;
        object-fit: cover;
        border-radius: 4px;
      }

      .header-default-6 .write-review-button {
        width: 100%;
        min-height: 42px;
        box-sizing: border-box;
      }
    }

    @media (max-width: 768px) {
      body.header-default-6.body-default-4:not(.popup-write-review) {
        padding: 0 12px 24px;
      }

      .header-default-6 .header-container {
        padding-top: 0;
      }

      .header-default-6 .header-container .scm-row {
        margin: 0;
      }

      .header-default-6 .left-header,
      .header-default-6 .right-header {
        flex: 0 0 100%;
        width: 100%;
        max-width: 100%;
        padding: 0;
      }

      .header-default-6 .scmRating1 {
        width: 100%;
        margin-bottom: 12px;
      }

      .header-default-6 .scmRating1 .info {
        display: grid;
        grid-template-columns: auto auto;
        justify-content: center;
        align-items: center;
        column-gap: 10px;
      }

      .header-default-6 .scmRating1 .number {
        grid-row: 1 / span 2;
        width: auto;
        margin: 0;
      }

      .header-default-6 .scmRating1 .number #average {
        font-size: 32px;
        line-height: 1;
      }

      .header-default-6 .scmRating1 .block-star-avenge,
      .header-default-6 .scmRating1 .text-number {
        justify-content: flex-start;
        margin: 0;
      }

      .header-default-6 .scmRating2 {
        width: 100%;
        margin-bottom: 12px;
        padding: 0;
        border-left: 0;
        border-right: 0;
      }

      .header-default-6 .scmRating2 .group-progress-bar {
        width: min(100%, 270px);
        margin: 0 auto;
      }

      .header-default-6 .scmRating2 .item-progress-bar {
        margin-bottom: 3px;
      }

      .header-default-6 .scmRating3 {
        width: 100%;
        margin-bottom: 12px;
        padding: 0;
      }

      .header-default-6 .images-container-reviews {
        width: 100%;
        padding: 0 0 4px;
      }

      .header-default-6 .images-container-reviews .thumb-img img,
      .header-default-6 .images-container-reviews .number-img {
        width: 84px;
        height: 84px;
        margin: 0;
        object-fit: cover;
        border-radius: 4px;
      }

      .header-default-6 .right-header .buttons-container {
        width: 100%;
        margin: 0;
      }

      .header-default-6 .write-review-button {
        display: block;
        width: 100%;
        min-height: 42px;
        margin: 0 0 10px;
        box-sizing: border-box;
      }

      .header-default-6 .container-sort {
        width: 100%;
        margin: 8px 0 0;
      }

      .header-default-6 .scm-sort {
        float: none;
        width: 100%;
        min-width: 0;
      }

      .header-default-6 .scm-sort .scm-sort-title {
        justify-content: center;
        width: 100%;
        min-height: 42px;
        box-sizing: border-box;
      }

      .header-default-6 #reviewImporter {
        margin-top: 4px;
      }
    }
  `;

  function installLaiPhotoLayout(frame) {
    try {
      var iframeDocument = frame.contentDocument;
      if (!iframeDocument || !iframeDocument.head) return false;
      if (!iframeDocument.getElementById(LAI_PHOTO_LAYOUT_STYLE_ID)) {
        var style = iframeDocument.createElement('style');
        style.id = LAI_PHOTO_LAYOUT_STYLE_ID;
        style.textContent = LAI_PHOTO_LAYOUT_CSS;
        iframeDocument.head.appendChild(style);
      }
      if (frame.contentWindow) frame.contentWindow.dispatchEvent(new frame.contentWindow.Event('resize'));
      return true;
    } catch (error) {
      return false;
    }
  }

  function setupLaiPhotoLayouts() {
    document.querySelectorAll('iframe.scm-reviews-importer-iframe').forEach(function (frame) {
      if (frame.dataset.kgyLaiPhotoLayoutReady !== 'true') {
        frame.dataset.kgyLaiPhotoLayoutReady = 'true';
        frame.addEventListener('load', function () {
          window.setTimeout(function () { installLaiPhotoLayout(frame); }, 0);
        });
      }
      installLaiPhotoLayout(frame);
    });
  }
  /* KGY-LAI-PHOTO-LAYOUT-20261014 END */

  /* KGY-LAI-RATING-COLLAPSE-20261014 BEGIN: mobile-only, fail-open rating distribution toggle. */
  var LAI_RATING_COLLAPSE_STYLE_ID = 'kgy-lai-rating-collapse';
  var LAI_RATING_COLLAPSE_CSS = `
    @media (max-width: 768px) {
      body.header-default-6.kgy-lai-rating-toggle-ready .scmRating1 .info {
        grid-template-columns: auto auto 24px;
        width: 100%;
        min-height: 44px;
        padding: 6px 8px;
        cursor: pointer;
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;
      }

      body.header-default-6.kgy-lai-rating-toggle-ready .scmRating1 .info::after {
        content: '';
        grid-column: 3;
        grid-row: 1 / span 2;
        align-self: center;
        justify-self: center;
        width: 8px;
        height: 8px;
        border-right: 1.5px solid currentColor;
        border-bottom: 1.5px solid currentColor;
        transform: rotate(45deg) translate(-2px, -2px);
        transition: transform 160ms ease;
      }

      body.header-default-6.kgy-lai-rating-toggle-ready.kgy-lai-rating-details-open .scmRating1 .info::after {
        transform: rotate(225deg) translate(-2px, -2px);
      }

      body.header-default-6.kgy-lai-rating-toggle-ready .scmRating2 {
        display: none;
      }

      body.header-default-6.kgy-lai-rating-toggle-ready.kgy-lai-rating-details-open .scmRating2 {
        display: flex;
      }

      body.header-default-6.kgy-lai-rating-toggle-ready .scmRating1 {
        margin-bottom: 8px;
      }

      body.header-default-6.kgy-lai-rating-toggle-ready.kgy-lai-rating-details-open .scmRating1 {
        margin-bottom: 12px;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      body.header-default-6.kgy-lai-rating-toggle-ready .scmRating1 .info::after {
        transition: none;
      }
    }
  `;

  function bindLaiRatingToggle(frame) {
    try {
      var iframeWindow = frame.contentWindow;
      var iframeDocument = frame.contentDocument;
      if (!iframeWindow || !iframeDocument || !iframeDocument.body) return false;

      var trigger = iframeDocument.querySelector('.header-container .scmRating1 .info');
      var details = iframeDocument.querySelector('.header-container .scmRating2');
      if (!trigger || !details) return false;

      var media = iframeWindow.matchMedia('(max-width: 768px)');
      var detailsId = details.id || 'kgy-lai-rating-details';
      details.id = detailsId;

      function syncRatingToggleMode() {
        if (media.matches) {
          iframeDocument.body.classList.add('kgy-lai-rating-toggle-ready');
          trigger.setAttribute('role', 'button');
          trigger.setAttribute('tabindex', '0');
          trigger.setAttribute('aria-controls', detailsId);
          trigger.setAttribute('aria-expanded', iframeDocument.body.classList.contains('kgy-lai-rating-details-open') ? 'true' : 'false');
        } else {
          iframeDocument.body.classList.remove('kgy-lai-rating-toggle-ready', 'kgy-lai-rating-details-open');
          trigger.removeAttribute('role');
          trigger.removeAttribute('tabindex');
          trigger.removeAttribute('aria-controls');
          trigger.removeAttribute('aria-expanded');
        }
      }

      function toggleRatingDetails() {
        if (!media.matches) return;
        var open = iframeDocument.body.classList.toggle('kgy-lai-rating-details-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        iframeWindow.dispatchEvent(new iframeWindow.Event('resize'));
      }

      if (trigger.dataset.kgyLaiRatingToggleReady !== 'true') {
        trigger.dataset.kgyLaiRatingToggleReady = 'true';
        trigger.addEventListener('click', toggleRatingDetails);
        trigger.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleRatingDetails();
          }
        });
        iframeWindow.addEventListener('resize', syncRatingToggleMode);
      }

      syncRatingToggleMode();
      return true;
    } catch (error) {
      return false;
    }
  }

  function installLaiRatingCollapse(frame) {
    try {
      var iframeDocument = frame.contentDocument;
      if (!iframeDocument || !iframeDocument.head) return false;
      if (!iframeDocument.getElementById(LAI_RATING_COLLAPSE_STYLE_ID)) {
        var style = iframeDocument.createElement('style');
        style.id = LAI_RATING_COLLAPSE_STYLE_ID;
        style.textContent = LAI_RATING_COLLAPSE_CSS;
        iframeDocument.head.appendChild(style);
      }
      return bindLaiRatingToggle(frame);
    } catch (error) {
      return false;
    }
  }

  function setupLaiRatingCollapses() {
    document.querySelectorAll('iframe.scm-reviews-importer-iframe').forEach(function (frame) {
      if (frame.dataset.kgyLaiRatingCollapseReady !== 'true') {
        frame.dataset.kgyLaiRatingCollapseReady = 'true';
        frame.addEventListener('load', function () {
          window.setTimeout(function () { installLaiRatingCollapse(frame); }, 0);
          window.setTimeout(function () { installLaiRatingCollapse(frame); }, 500);
        });
      }
      installLaiRatingCollapse(frame);
    });
  }
  /* KGY-LAI-RATING-COLLAPSE-20261014 END */

  /* KGY-LAI-MOBILE-SORT-20261014 BEGIN: compact right-aligned mobile sort control; no color overrides. */
  var LAI_MOBILE_SORT_STYLE_ID = 'kgy-lai-mobile-sort-position';
  var LAI_MOBILE_SORT_CSS = `
    @media (max-width: 768px) {
      .header-default-6 .container-sort {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        margin: 0 0 10px;
        padding: 0;
      }

      .header-default-6 .container-sort .scm-sort {
        float: none;
        width: auto;
        min-width: 0;
        margin: 0 0 0 auto;
      }

      .header-default-6 .container-sort .scm-sort .scm-sort-title {
        justify-content: flex-end;
        width: auto;
        min-height: 36px;
        padding: 6px 0 6px 12px;
        box-sizing: border-box;
      }

      .header-default-6 .right-header .write-review-button {
        margin-bottom: 6px;
      }
    }
  `;

  function installLaiMobileSortPosition(frame) {
    try {
      var iframeDocument = frame.contentDocument;
      if (!iframeDocument || !iframeDocument.head) return false;
      if (!iframeDocument.getElementById(LAI_MOBILE_SORT_STYLE_ID)) {
        var style = iframeDocument.createElement('style');
        style.id = LAI_MOBILE_SORT_STYLE_ID;
        style.textContent = LAI_MOBILE_SORT_CSS;
        iframeDocument.head.appendChild(style);
      }
      if (frame.contentWindow) frame.contentWindow.dispatchEvent(new frame.contentWindow.Event('resize'));
      return true;
    } catch (error) {
      return false;
    }
  }

  function setupLaiMobileSortPositions() {
    document.querySelectorAll('iframe.scm-reviews-importer-iframe').forEach(function (frame) {
      if (frame.dataset.kgyLaiMobileSortReady !== 'true') {
        frame.dataset.kgyLaiMobileSortReady = 'true';
        frame.addEventListener('load', function () {
          window.setTimeout(function () { installLaiMobileSortPosition(frame); }, 0);
        });
      }
      installLaiMobileSortPosition(frame);
    });
  }
  /* KGY-LAI-MOBILE-SORT-20261014 END */

  function findReviewItems(root) {
    var candidates = uniqueElements(root.querySelectorAll(ITEM_SELECTORS.join(',')));
    var items = candidates.filter(function (element) {
      return isReviewItem(element, root);
    });

    if (items.length <= 1) {
      var fallback = Array.prototype.filter.call(root.children, function (element) {
        return isReviewItem(element, root);
      });
      items = items.concat(fallback);
    }

    return uniqueElements(items).filter(function (item) {
      return !items.some(function (other) {
        return other !== item && other.contains(item) && isReviewItem(other, root);
      });
    });
  }

  function createButton(root) {
    var wrap = root.querySelector(':scope > .lai-review-collapse__toggle-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'lai-review-collapse__toggle-wrap';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'lai-review-collapse__toggle';
      button.setAttribute('aria-expanded', 'false');
      button.innerHTML = '<span class="lai-review-collapse__toggle-text">レビューをもっと見る</span><span class="lai-review-collapse__toggle-icon" aria-hidden="true"></span>';
      button.addEventListener('click', function () {
        var expanded = root.classList.toggle('lai-review-collapse--expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.querySelector('.lai-review-collapse__toggle-text').textContent = expanded ? 'レビューを閉じる' : 'レビューをもっと見る';
        applyCollapse(root);
      });

      wrap.appendChild(button);
    }

    return wrap;
  }

  function insertAfterLastItem(root, items, wrap) {
    var lastItem = items[items.length - 1];
    if (!lastItem) {
      return;
    }
    if (lastItem.nextElementSibling !== wrap) {
      lastItem.insertAdjacentElement('afterend', wrap);
    }
  }

  function resetPrevious(root) {
    root.querySelectorAll('.lai-review-collapse__hidden').forEach(function (element) {
      element.classList.remove('lai-review-collapse__hidden');
    });
  }

  function applyCollapse(root) {
    if (root.dataset.laiReviewCollapseApplying === 'true') {
      return;
    }

    root.dataset.laiReviewCollapseApplying = 'true';
    resetPrevious(root);

    var items = findReviewItems(root);
    var wrap = root.querySelector(':scope > .lai-review-collapse__toggle-wrap');

    if (items.length <= COLLAPSE_LIMIT) {
      root.classList.remove('lai-review-collapse', 'lai-review-collapse--expanded');
      if (wrap) {
        wrap.remove();
      }
      root.dataset.laiReviewCollapseApplying = 'false';
      return;
    }

    root.classList.add('lai-review-collapse');
    var expanded = root.classList.contains('lai-review-collapse--expanded');

    items.forEach(function (item, index) {
      if (!expanded && index >= COLLAPSE_LIMIT) {
        item.classList.add('lai-review-collapse__hidden');
      }
    });

    wrap = createButton(root);
    insertAfterLastItem(root, expanded ? items : items.slice(0, COLLAPSE_LIMIT), wrap);

    root.dataset.laiReviewCollapseApplying = 'false';
  }

  function setupRoot(root) {
    if (root.dataset.laiReviewCollapseReady === 'true') {
      applyCollapse(root);
      return;
    }

    root.dataset.laiReviewCollapseReady = 'true';
    applyCollapse(root);

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (root.dataset.laiReviewCollapseApplying === 'true') {
        return;
      }
      if (scheduled) {
        return;
      }
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        applyCollapse(root);
      });
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function init() {
    getRoots().forEach(setupRoot);
    setupLaiMobileLayouts();
    setupLaiPhotoLayouts();
    setupLaiRatingCollapses();
    setupLaiMobileSortPositions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
  window.setTimeout(init, 800);
  window.setTimeout(init, 1800);
  window.setTimeout(init, 3500);
})();
